import React from 'react';
import './Banner.css';
import { useDispatch, useSelector } from 'react-redux';
import { CenteredBannerLayout } from './CenteredBannerLayout';
import { DefaultBannerLayout } from './DefaultBannerLayout';
import { OffersDataService } from '../../../services/offers-data.service';
import { AppService } from '../../../../shared/src/services/app.service';
import { AppActionEnum } from '../../../../shared/src/enums/app-action.enum';
import { PlayerService } from '../../../../shared/src/services/player.service';

export const Banner = () => {
    const { mainBannerLayout, html } = OffersDataService.getOffersData();
    const { pagePurpose } = OffersDataService.getOffersData();
    const { platformReady } = useSelector(state => state.app);
    const isPayNPlayEnabled = platformReady && AsgFW.isPayNPlayAvailable();
    const isLanding = pagePurpose === 'landing';
    const dispatch = useDispatch();
    const openRegistration = () => AppService.ctaHandler(AppActionEnum.REGISTRATION, null, dispatch);
    const bannerCtaAction = PlayerService.showLoginOrRegistration;

    const handleBannerClick = () => isLanding ? openRegistration() : bannerCtaAction();

    return (<section className={`homepage-banner-container ${mainBannerLayout}`}>
        {(mainBannerLayout === 'left' || mainBannerLayout === 'right') &&
            <DefaultBannerLayout
                isPayNPlayEnabled={isPayNPlayEnabled}
                bannerAction={handleBannerClick}
            />}

        {mainBannerLayout === 'center' &&
            <CenteredBannerLayout
                isPayNPlayEnabled={isPayNPlayEnabled}
                bannerAction={handleBannerClick}
            />}

        {html && <div dangerouslySetInnerHTML={{ __html: html }} />}
    </section>);
};
